module.exports = __webpack_public_path__ + "img/sj.0ec6c007.png";